import React from "react";
import { useReveal } from "../lib/useReveal";

export const Preservation = () => {
  const ref = useReveal();
  return (
    <section id="preservation" className="section reveal" ref={ref} data-testid="preservation-section">
      <div className="shell">
        <div style={{ maxWidth: 880 }}>
          <span className="section__eyebrow">Preservation Statement</span>
          <h2 style={{ marginTop: 0 }}>
            We do not get to keep what we refuse to remember.
          </h2>
          <p style={{
            fontFamily: "var(--font-display)",
            fontSize: "clamp(1.25rem, 1.7vw, 1.6rem)",
            fontStyle: "italic",
            lineHeight: 1.45,
            color: "hsl(var(--ink-soft))",
            marginTop: "1.5rem",
          }}>
            Some dates on this site are written into federal law. Some live in state codes,
            classroom posters, family kitchens, and the hard memory of communities that have
            kept their own records when the country tried not to keep them. All of them belong here.
          </p>
          <div className="callout-rule" style={{ marginTop: "2.5rem" }} />
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
            Will Not Be Forgotten exists to elevate dates that are often minimized, sanitized, or pushed
            to the margins — not by repealing them, but by quietly draining their meaning. We document each
            entry with care, distinguish federal recognition from state and cultural commemoration, and link
            to credible sources so readers can keep learning beyond this archive.
          </p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
            We are not a partisan project. We are a memory project. The communities whose histories appear here
            are not optional. The struggles their dates name are not finished. A democracy keeps its promises
            only by keeping its records honest.
          </p>
          <blockquote style={{
            margin: "3rem 0 0",
            padding: "1.5rem 2rem",
            borderLeft: "3px solid hsl(var(--accent))",
            background: "hsl(var(--bg-elev))",
            fontFamily: "var(--font-display)",
            fontSize: "1.4rem",
            fontStyle: "italic",
            lineHeight: 1.4,
            color: "hsl(var(--ink))",
          }}>
            “There is no bottom to a country that loses interest in remembering itself. There is
            also no ceiling to what it can become if it tells the truth.”
            <footer style={{
              marginTop: "1rem",
              fontFamily: "var(--font-body)",
              fontSize: "0.85rem",
              fontStyle: "normal",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "hsl(var(--muted))",
            }}>
              — Editorial statement, Will Not Be Forgotten
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
};
